import { BoxProps, Typography } from '@mui/material'
import { FlexCol, FlexRow } from '@xylabs/sdk-react'
import React from 'react'

import ItemSlot from './ItemSlot'
import ItemSlotViewer from './ItemSlotViewer'

interface ItemContainerProps extends BoxProps {
  name: string
  slots: ItemSlot[][]
}

const ItemContainer: React.FC<ItemContainerProps> = ({ slots, name, ...props }) => {
  return (
    <FlexCol alignItems="stretch" {...props}>
      <FlexRow marginBottom={1}>
        <Typography variant="caption">{name}</Typography>
      </FlexRow>
      <FlexRow paper flexWrap="wrap" border="1px gray solid" justifyContent="flex-start">
        {slots.map((slotRow, slotIndex) => {
          return slotRow.map((slot, rowIndex) => {
            return (
              <FlexRow key={`${slotIndex}-${rowIndex}`} padding={1}>
                <ItemSlotViewer itemSlot={slot} hint="always" />
              </FlexRow>
            )
          })
        })}
      </FlexRow>
    </FlexCol>
  )
}

export default ItemContainer
